module.exports = __webpack_public_path__ + "img/icon_submit_success.22c0cc08.png";